import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CreateRequisitionForm from "@/components/app/CreateRequisitionForm.vue";
import ListRequisitionTable from "@/components/app/ListRequisitionTable.vue";
import {ref} from "vue";

// Define component props

export default /*#__PURE__*/_defineComponent({
  __name: 'RequisitionView',
  setup(__props) {


const requisitionTable = ref()

function handleItemCreated(data: any) {
  requisitionTable.value.reload()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CreateRequisitionForm, { onItemCreated: handleItemCreated }),
    _createVNode(ListRequisitionTable, {
      ref_key: "requisitionTable",
      ref: requisitionTable
    }, null, 512)
  ], 64))
}
}

})